import { createContext, useContext } from "react";

export const ModalContext = createContext({
  openJoin: () => {},
  openValidator: () => {},
  setReferral: () => {},
});

export const useModals = () => useContext(ModalContext);

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const inputCls =
  "w-full bg-white/[0.03] border border-white/10 rounded-lg px-4 py-3 text-sm text-mist placeholder:text-zinc-600 focus:outline-none focus:border-signal-cyan/60 focus:ring-1 focus:ring-signal-cyan/30 transition-colors";

export const labelCls =
  "block text-sm font-medium text-steel mb-2";
